<template>
  <div class="container mt-4">
    <div @click="navigateToAccountView()" style="cursor: pointer;">
      <b-icon icon="chevron-left"></b-icon>&nbsp;Zurück
    </div>

    <b-card class="mt-4">
      <h1 class="mb-4 text-center">E-Mail ändern</h1>

      <b-form @submit.prevent="handleEmailChange()">
        <b-form-group id="input-group-email" label-for="input-email" description=" Stelle sicher, dass die E-Mail Adresse korrekt ist, da wir sie zur Authentifizierung nutzen.">
          <b-form-input
            id="input-email"
            v-model="email"
            type="email"
            placeholder="Neue E-Mail Adresse"
            required
          ></b-form-input>
        </b-form-group>

        <b-button
          type="submit"
          variant="primary"
          class="mt-3"
          style="width: 100%; background-color: #b02a2a; border-color: #b02a2a"
          >E-Mail ändern</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import { logout } from "@/services/auth";

export default {
  name: "accountGeneralView",
  components: {},
  data() {
    return {
      email: null,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    handleEmailChange() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      const body = {
        email: this.email,
      };

      axios
        .post(this.apiUrl + "/account/security/change-email", body)
        .then(async (response) => {
          Toast.fire({
            icon: "success",
            title: "E-Mail geändert",
            text: "Du wirst jetzt ausgeloggt...",
          });
          await logout();
          this.$router.push("/login");
          return response.data;
        });
    },

    navigateToAccountView() {
      this.$router.push(`/account`);
    },
  },

  beforeMount() {},
};
</script>

<style scoped>
small {
  display: block;
  text-align: center;
  font-size: 0.8em;
}
</style>
